module.exports = __webpack_public_path__ + "frontend/images/logos/small/small-white.png?6cf87e50b58d5199dd8dc482d12b8eb0";